<template lang="pug">
    .container
        .title-container
            .title-group
                p.step 
                    strong STEP 05: 
                    | Dining Area
                h3 Tell us about your meal preferences

            .button-wrap
                router-link.button(to="/activities") Skip this step

        .note.alert.alert-warning
            p
                | Please note that this meal plan is applicable for 
                b check-in day 
                | only.
            p
                | Please contact our help desk on 
                b 
                    a(href="tel:+94354761515") +94354761515 
                |  or 
                b 
                    a(href="tel:+9477114055") +9477114055 
                |  for further clarifications.

            p
                | If there is any additional meal requirement please go to 
                b Step No 07 ( Additional information & conformation)
                |  & mention it in the comment box 

        .meal-container
            meal(v-for="meal in allMeals" :meal="meal" :key="meal.id" @pickedMeal="pickedMeal" @pickedMealData="pickedMealData" @clickedMeal="clickedMeal")

        .button-row
            a.back(href="" @click.prevent="$router.go(-1)") 
                i.fa.fa-angle-left
                | Back

            a.next(href="" :class="{ active: isChecked }" @click.prevent="saveThirdStep") Proceed

        //- meal popup
        mealpopup(:singleMeal="mealData" ref="mealPopup")             
           
</template>

<script>
    import meal from './Meal'
    import mealpopup from './MealPopup'    
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'MealPreference',
        data() {
            return {
                isChecked: false,
                selectedMealData: []
            }
        },
        components: {
            meal,
            mealpopup
        },
        computed: mapGetters(['allMeals', 'mealData']),
        methods: {
            ...mapActions(['fetchMeals', 'postThirdStepBooking', 'addToTotal', 'getMeal']),
            clickedMeal(selectedMeal) {
                if(selectedMeal) {
                    this.getMeal(selectedMeal.meal_plan_id).then(() => {
                        this.$refs.mealPopup.toggle();
                    });
                }
            },            
            pickedMeal(selectedMeal) {
                if(selectedMeal) {
                    selectedMeal.forEach(m => {
                        if(m.checked == true) {
                            this.isChecked = true;

                            var item = this.selectedMealData.find(n => n.meal_plan_id === m.meal_plan_id);
                            if(item) { return Object.assign(item, m); }
                            this.selectedMealData.push(m);
                        } else {
                            this.removeItem(this.selectedMealData, 'meal_plan_id', m.meal_plan_id);                            
                        }
                    });
                }
            },
            pickedMealData(selectedMeal) {
                if(selectedMeal) {
                    selectedMeal.forEach(m => {
                        var item = this.selectedMealData.find(n => n.meal_plan_id === m.meal_plan_id);
                        if(item) { return Object.assign(item, m); }
                        this.selectedMealData.push(m);
                    });
                }                
            },            
            removeItem(array, element, item){
                for(var i in array){
                    if(array[i][element] == item){
                        array.splice(i,1);
                        break;
                    }
                }
            },
            saveThirdStep() {
                var total = 0;

                this.selectedMealData.forEach(data => {
                    total += data.meal_cost; 
                });

                for(var i in this.selectedMealData){
                    delete this.selectedMealData[i].checked;
                    delete this.selectedMealData[i].meal_cost;
                }

                // var booking_id;

                // if (window.localStorage.getItem("firstStepBookingId") === null) {
                //     booking_id = window.localStorage.setItem("firstStepBookingId", this.$route.params.id); 
                // } else {
                //     booking_id = window.localStorage.getItem("firstStepBookingId"); 
                // }                

                var bookingData = {
                    "booking_id": parseInt(window.localStorage.getItem('firstStepBookingId')),
                    "meal_plans": this.selectedMealData 
                };

                var totalData = {
                    "type": 'meal',
                    "total": total
                }
                
                //add to main total
                this.addToTotal(totalData);

                this.postThirdStepBooking(bookingData).then(() => {
                    this.$router.push('/activities');
                });

            }                                   
        },
        created() {
            this.fetchMeals();
        }
    }
</script>

<style lang="sass">
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"
    @import "@/assets/css/3-components/_meal.sass"
</style>
